import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/fleet/")({
	component: () => <Navigate to="/fleet/vehicles" />,
});
